export default __webpack_public_path__ + "static/media/dashboard_userTesting.1f4d3b0f.jpg";